import Vue from 'vue'
import axios from 'axios'
axios.defaults.baseURL = "http://172.17.0.24:18004"

Vue.prototype.$http = axios;
